import './loading-spinner.scss';

(function ($, Drupal) {
  'use strict';

  function startLoadingSpinner() {
    if(document.querySelector("#loader") === null){
      return;
    }

    document.querySelector( ".ui-loader-background").style.display = "block";
    document.querySelector("#loader").style.visibility = "visible";
  }

  Drupal.behaviors.tink_loading_spinner = {
    attach: function (context, settings) {
      $('.non-member-login-form').on('submit', function(e) {
        e.preventDefault();
        startLoadingSpinner();
        this.submit();
      });

      $('.user-login-form').on('submit', function(e) {
        e.preventDefault();
        startLoadingSpinner();
        this.submit();
      });

      $('.broker-login-form').on('submit', function(e) {
        e.preventDefault();
        startLoadingSpinner();
        this.submit();
      });

      $('#submit-compliance').on('click', function(e) {
        e.preventDefault();
        startLoadingSpinner();
      });

      $('#submit-consent').on('click', function(e) {
        e.preventDefault();
        startLoadingSpinner();
      });

      $('#submit-manager').on('click', function(e) {
        e.preventDefault();
        startLoadingSpinner();
      });

      $('#block-brokerdelegations .pager .page-link').on('click', function(e) {
        startLoadingSpinner();
      });

      /* member, broker and non-member forgot passord */
      $('#user-pass').on('submit', function(e) {
        e.preventDefault();
        startLoadingSpinner();
        this.submit();
      });
    }
  };
})(jQuery, Drupal);


